import { useEffect } from "react";

/** Canonical public domain. Change here if the public site moves. */
export const SITE_URL = "https://shineywise.com";

function upsertMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href: string) {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/** Set per-page title / description / canonical / Open Graph.
 *
 * The SPA serves one index.html, so without this every route shares the same
 * title and canonical. Google renders JS, so updating these on mount gives each
 * public page its own correct metadata for crawling and indexing. */
export function useSeo({
  title,
  description,
  path,
}: {
  title: string;
  description?: string;
  path?: string;
}) {
  useEffect(() => {
    const fullTitle = title.includes("Shineywise") || title.includes("Wise 2.0")
      ? title
      : `${title} · Wise 2.0 by Shineywise`;
    document.title = fullTitle;
    upsertMeta("property", "og:title", fullTitle);

    if (description) {
      upsertMeta("name", "description", description);
      upsertMeta("property", "og:description", description);
      upsertMeta("name", "twitter:description", description);
    }

    const url = SITE_URL + (path ?? window.location.pathname);
    upsertCanonical(url);
    upsertMeta("property", "og:url", url);
  }, [title, description, path]);
}
